// @ts-nocheck
import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Trophy } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import RLHoopsStandingsTable from '@/components/public/rlhoops/RLHoopsStandingsTable';
import { format } from 'date-fns';

const SEASON = '2025-2026';
const DIVISIONS = [
  { value: '17u', label: '17U' },
  { value: '16u', label: '16U' },
  { value: '15u', label: '15U' },
];

const HighSchoolStandings: React.FC = () => {
  const [activeTab, setActiveTab] = useState('17u');

  const { data: lastUpdated } = useQuery({
    queryKey: ['rlhoops-last-updated', 'high-school', SEASON],
    queryFn: async () => {
      const { data } = await supabase
        .from('rlhoops_team_rankings')
        .select('last_updated')
        .in('age_group', ['17u', '16u', '15u'])
        .eq('season', SEASON)
        .order('last_updated', { ascending: false })
        .limit(1);
      return data?.[0]?.last_updated ?? null;
    },
  });

  return (
    <div className="max-w-5xl mx-auto px-4 py-10 sm:py-14">
      <div className="mb-8 text-center">
        <div className="inline-flex items-center gap-2 text-primary mb-2">
          <Trophy className="h-6 w-6" />
          <span className="text-sm font-semibold uppercase tracking-wider">RLHoops {SEASON} Season</span>
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-foreground">High School Rankings</h1>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="w-full justify-center mb-6">
          {DIVISIONS.map((d) => (
            <TabsTrigger key={d.value} value={d.value} className="text-base px-6 py-3 font-semibold">
              {d.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {DIVISIONS.map((d) => (
          <TabsContent key={d.value} value={d.value}>
            <RLHoopsStandingsTable ageGroup={d.value} season={SEASON} />
          </TabsContent>
        ))}
      </Tabs>

      {lastUpdated && (
        <p className="mt-6 text-center text-xs text-muted-foreground">
          Last updated: {format(new Date(lastUpdated), 'MMM d, yyyy h:mm a')}
        </p>
      )}
    </div>
  );
};

export default HighSchoolStandings;
